export default "__VITE_ASSET__91cCHyHn__"